var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "box", staticClass: "box" }, [
    _c(
      "div",
      _vm._b(
        { staticClass: "number", style: _vm.numberStyle },
        "div",
        _vm.$attrs,
        false
      ),
      [_vm._v("\n        " + _vm._s(_vm.currentNumber) + "\n    ")]
    ),
    _vm._v(" "),
    _vm.shadow
      ? _c(
          "div",
          _vm._b(
            { staticClass: "shadow-number", style: _vm.shadowNumberStyle },
            "div",
            _vm.$attrs,
            false
          ),
          [_vm._v("\n        " + _vm._s(_vm.currentNumber) + "\n    ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }